import React from 'react';
import * as Sentry from '@sentry/react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const ENABLED_ENVIRONMENTS = ['prod', 'demo', 'dev'];
const ENVIRONMENT = process.env.VITE_ENVIRONMENT ?? 'local';
const enabled = ENABLED_ENVIRONMENTS.includes(ENVIRONMENT);

Sentry.init({
  enabled,
  dsn: 'https://4bcf233c50092c417952e4fc06a956a2@o294755.ingest.us.sentry.io/4509374432411648',
  environment: ENVIRONMENT,
  release: process.env.VITE_HARBOR_VERSION,
  sendDefaultPii: true,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  ignoreErrors: [/^Api Call Failed: Status: 401/],
  tracesSampleRate: parseFloat(
    process.env.VITE_SENTRY_TRACE_SAMPLE_RATE ?? '0.0'
  ),
  tracePropagationTargets: [
    /^http:\/\/localhost:8000\/api/,
    /^https:\/\/api-dev\.pathfinder\.wellstoneapps\.com\/api/,
    /^https:\/\/api-demo\.pathfinder\.wellstoneapps\.com\/api/,
    /^https:\/\/api\.pathfinder\.wellstoneapps\.com\/api/,
  ],

  beforeSend(event) {
    // Prevent Sentry from logging user's passwords
    const data = event.request?.data as Record<string, unknown>;

    if (data && typeof data === 'object' && !Array.isArray(data)) {
      const ignoreAttributes = ['password', 'passwordConfirmation'];

      for (const key of ignoreAttributes) {
        if (key in data) data[key] = '[PRIVATE]';
      }
    }

    return event;
  },

  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'console' && breadcrumb.level === 'log') {
      return null;
    }

    return breadcrumb;
  },
});

export const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
